import {useEffect} from "react";
import {Button, Alert} from "antd";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {formatDate, formatDateTime, useIsMobile} from "../../../../../_common/function";
import {Avatar, Badge, Col, Image, List, Modal, Row, Typography} from "antd";
import VirtualList from "rc-virtual-list";
import EmptyData from "../../../../../../brand/component/emptyData/view";
import Loader from "../../../../../../brand/component/loader/view";
import {useGetHeaderPushNotificationLogByUserId} from "../../../function";
import {updatePushNotificationLogReadStatus} from "../../../../../api/graphql/pushNotification";
import {useSetRecoilState} from "recoil";
import {globalUnreadPushNotificationCountState} from "../../../../../_common/global_state";
import {NotificationOutlined} from "@ant-design/icons";

const {Paragraph} = Typography

// the cap the list scrolls within; fullHeight={false} makes it a max-height, so a
// short list hugs its rows instead of reserving the whole 400px
const CONTAINER_HEIGHT = 400;

const PushNotificationListing_2 = (props) => {
    const {isHeader} = props
    const isMobile = useIsMobile();
    const {t} = useTranslation();
    const [data, total, fetchPage, loading, loadError] = useGetHeaderPushNotificationLogByUserId();
    useEffect(() => { fetchPage(); }, []);

    const [selected, setSelected] = useState({})
    const [modalOpen, setModalOpen] = useState(false);
    const [currentData, setCurrentData] = useState({})
    const [updatedRead, setUpdatedRead] = useState([])

    const setUnreadPushNotificationCount = useSetRecoilState(globalUnreadPushNotificationCountState);

    const renderTinyMCEContent = (content) => {
        const cleanContent = (content || '')
            ?.replace(/<\/?body[^>]*>/gi, '')
            ?.replace(/<img /g, '<img onerror="this.style.display=\'none\'" ');
        return <div className={"tinyMceParagraph"} dangerouslySetInnerHTML={{__html: cleanContent}}/>
    }

    const selectItem = () => {
        setSelected({})
    }

    // useEffect(() => {
    //     if (!!data?.length) {
    //         if (!isMobile) {
    //             selectItem(data?.[0]);
    //         }
    //     } else {
    //         setSelected([]);
    //     }
    // }, [data])

    const loadingComponent = (
        <Col span={24} className={"mb-6"}>
            <div className={"flex items-center justify-center min-h-[400px]"}>
                <Loader/>
            </div>
        </Col>
    )

    const dateToday = formatDate(new Date(), true, "YYYY-MM-DD")

    const listComponent = (
        <List>
            {loadError && <Alert type="error" message="Could not load notifications" action={<Button onClick={() => fetchPage()}>Retry</Button>}/>}
            <VirtualList
                className={"cursor-pointer"}
                data={data}
                height={CONTAINER_HEIGHT}
                fullHeight={false}
                itemHeight={47}
                itemKey={"_id"}
            >
                {(item) => {
                    const time = item?.createdAt
                    const isToday = formatDate(time, true, "YYYY-MM-DD") === dateToday
                    const isUnread = !item?.isRead && !updatedRead.includes(item?._id)
                    // the payload can arrive without a title — promote the body rather than
                    // drawing a row with nothing in it
                    const heading = item?.notification?.title
                        || item?.notification?.body
                        || t("pushNotification.untitled", {defaultValue: "Notification"})
                    const body = item?.notification?.title ? item?.notification?.body : null

                    const openItem = async () => {
                        if (isHeader) {
                            setCurrentData(item)
                            setModalOpen(true);
                            if (isUnread) {
                                const res = await updatePushNotificationLogReadStatus([item?._id], true)
                                if (res?.updatePushNotificationLogReadStatus?.status === "success") {
                                    setUpdatedRead(prev => [...prev, item?._id])
                                    setUnreadPushNotificationCount(prev => prev - 1)
                                }
                            }
                            // else if (!updatedRead.includes(item?._id)) {
                            //     const res = await updatePushNotificationLogReadStatus([item?._id], true)
                            //     setUpdatedRead(prev => [...prev, res?.updatePushNotificationLogReadStatus[0]?._id])
                            // }

                            // setMessage({
                            //     status: "open",
                            //     title: item?.notification?.title,
                            //     msg: <>
                            //         {item?.notification?.body}
                            //         <Image src={item?.notification?.image} preview={false}/>
                            //     </>,
                            //     icon: <Image src={item?.notification?.icon} preview={false}/>,
                            //     onClose: async () => {
                            //         const res = await updatePushNotificationLogReadStatus([item?._id], true)
                            //         if (res?.updatePushNotificationLogReadStatus?.status === "success") {
                            //             setUpdatedRead(prev => [...prev, item?._id])
                            //             setUnreadPushNotificationCount(prev => prev - 1)
                            //         }
                            //     }
                            // })
                        } else {
                            selectItem()
                        }
                    }

                    return (
                        <div
                            role={"button"}
                            tabIndex={0}
                            className={"text-start push-notification-card" + (isUnread ? " is-unread" : "")}
                            onClick={openItem}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault()
                                    openItem()
                                }
                            }}
                        >
                            <Row wrap={false} gutter={[12, 0]}>
                                <Col flex={"none"}>
                                    <Badge
                                        offset={[-35, 5]}
                                        dot={isUnread}
                                    >
                                        <Avatar
                                            size={40}
                                            src={item?.notification?.icon}
                                            shape={"circle"}
                                            icon={<NotificationOutlined/>}
                                        />
                                    </Badge>
                                </Col>
                                <Col flex={"auto"}>
                                    <Row wrap={false} align={"middle"} gutter={8}>
                                        <Col flex={"auto"}>
                                            <Paragraph ellipsis={{rows: 1}} className={"title"}>
                                                {heading}
                                            </Paragraph>
                                        </Col>
                                        <Col flex={"none"} className={"text-end date-time"}>
                                            {formatDateTime(time, isToday ? "hh:mm A" : "DD/MM, hh:mm A")}
                                        </Col>
                                    </Row>
                                    {body && (
                                        <Row wrap={false} align={"middle"}>
                                            <Col flex={"auto"}>
                                                <Paragraph ellipsis={{rows: 2}} className={"description"}>
                                                    {body}
                                                </Paragraph>
                                            </Col>
                                        </Row>
                                    )}
                                </Col>
                                {item?.notification?.image && (
                                    <Col flex={"none"} className={"push-notification-image"}>
                                        <Avatar src={item?.notification?.image} shape={"square"} size={55}/>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    )
                }}
            </VirtualList>
            {data?.length < total && <Button loading={loading} onClick={() => fetchPage(data.length)}>Load more</Button>}
        </List>
    )

    const emptyComponent = (
        <div className={"mx-auto mt-6"}>
            <EmptyData/>
        </div>
    )

    return (
        <div id={"pushNotificationListing"}>
            {loadError && <Alert type="error" message="Could not load notifications" action={<Button onClick={() => fetchPage()}>Retry</Button>}/>}
            {loading ? loadingComponent : !!data?.length ? listComponent : emptyComponent}
            <Modal
                title={
                    <>
                        {currentData?.notification?.title
                            || currentData?.notification?.body
                            || t("pushNotification.untitled", {defaultValue: "Notification"})}
                        <p className={"date-time"}>
                            {formatDateTime(currentData?.updatedAt || currentData?.createdAt, "MMMM Do YYYY, h:mm:ss a")}
                        </p>
                    </>
                }
                width={isMobile ? "90%" : "60%"}
                open={modalOpen}
                footer={null}
                onCancel={() => setModalOpen(false)}
                className={"push-notification-modal"}
                getContainer={() => document.querySelector("#layout-2")}
            >
                {currentData?.notification?.body && <p>{currentData?.notification?.body}</p>}
                {currentData?.notification?.image && (
                    <div className={"mt-4 text-center"}>
                        <Image src={currentData?.notification?.image} preview={false}/>
                    </div>
                )}
                {currentData?.longContent && (
                    <div className={"mt-4"}>{renderTinyMCEContent(currentData?.longContent)}</div>
                )}
            </Modal>
        </div>
    )
};

export default PushNotificationListing_2;